import { observer } from 'mobx-react';
import { FC, useCallback, useMemo } from 'react';
import { customerWalletModalStore } from '../../store';
import { VALIDITY_PERIOD } from 'src/constants/main';
import { localeStore } from 'src/mobx/localesStore';
import { capitalLetter } from 'src/utils/formatter';
import Input from 'src/view/components/Controls/InputComponent/Input';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types';
import TabPicker from 'src/view/components/Controls/Pickers/TabPicker/TabPicker';
import Text, { TEXT } from 'src/view/components/Text/Text';
import './style.scss';

const CustomerWalletModalValidity: FC = observer((): JSX.Element => {
  const { loading, topUp, validation } = customerWalletModalStore;

  const onPeriodStateChange = useCallback((duration: VALIDITY_PERIOD) => {
    customerWalletModalStore.updatePeriodState(duration);
  }, []);

  const onPeriodValueChange = useCallback((value: string | undefined) => {
    customerWalletModalStore.updatePeriodValue(value);
  }, []);

  const validityDurationOptions = useMemo((): IPickerOption[] => {
    return [
      { value: VALIDITY_PERIOD.DAYS, label: capitalLetter(localeStore.t('d')) },
      { value: VALIDITY_PERIOD.WEEKS, label: VALIDITY_PERIOD.WEEKS },
      { value: VALIDITY_PERIOD.MONTHS, label: VALIDITY_PERIOD.MONTHS },
      { value: VALIDITY_PERIOD.FOREVER, label: VALIDITY_PERIOD.FOREVER },
    ];
  }, []);

  return (
    <div className="d-flex flex-column gap-10">
      <Text type={TEXT.BLOCK_HEADER} text="validity" required />
      <div className="d-flex flex-row gap-10">
        <TabPicker value={topUp.periodState} options={validityDurationOptions} onChange={onPeriodStateChange} disabled={loading} />
        {topUp.periodState !== VALIDITY_PERIOD.FOREVER ? (
          <Input
            type="number"
            value={topUp.periodValue}
            onChangeValue={onPeriodValueChange}
            disabled={loading}
            validation={{ isValid: validation.period.isValid }}
            maxLength={3}
            placeholder="0"
            contentClassName="customer-wallet-modal-validity__input"
            inputClassName="text-center p-0"
          />
        ) : null}
      </div>
      {!validation.period.errorText ? null : <Text type={TEXT.ERROR} text={validation.period.errorText} className="mt-0" />}
    </div>
  );
});

export default CustomerWalletModalValidity;
